<template>
    <transition name="modal">
        <div class="modal-mask" @mousedown="close">
            <div class="modal-wrapper">
                <div class="container modal-container">
                    <!-- v-clickaway="close" -->
                    <div class="d-flex align-items-baseline mb-3">
                        <h4 class="flex-fill">
                            <slot name="head" />
                        </h4>

                        <button type="button" class="close" aria-label="Close">
                            <i class="tlm-icon-times" />
                        </button>
                    </div>

                    <div>
                        <slot />
                    </div>

                    <div>
                        <slot name="footer" />
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            shouldRemoveBodyClass: false
        }
    },

    beforeMount() {
        window.addEventListener('keyup', this.handleEscapeKeyUp)

        this.shouldRemoveBodyClass = !document.body.classList.contains('modal-visible')
        if (this.shouldRemoveBodyClass) {
            document.body.classList.add('modal-visible')
        }
    },

    beforeDestroy() {
        window.removeEventListener('keyup', this.handleEscapeKeyUp)

        if (this.shouldRemoveBodyClass) {
            document.body.classList.remove('modal-visible')
        }
    },

    methods: {
        close() {
            if (event.target.classList.contains('modal-wrapper') ||
                event.target.classList.contains('close') ||
                event.target.classList.contains('tlm-icon-times')
            ) {
                this.$emit('close')
            }
        },

        handleEscapeKeyUp(event) {
            if (event.which === 27) {
                this.$emit('close')
            }
        }
    }
}
</script>
